import React, { useState, useEffect } from "react";
import OverviewThumbnailPlaceholderImg from "../../img/placeholders/overview_thumbnail_placeholder.jpg";

// COMPONENTS
import Layout from "../layout/Layout";
import ToggleOpacity from "../features/ToggleOpacity";
import Title from "../text/Title";
import Icon from "../icons/Icon";

const PriviewOverview = ({ children, data }) => {
  const [contentVisible, setContentVisible] = useState(false);
  const [thumbnail, setThumbnail] = useState();

  const showContent = () => {
    setContentVisible(true);
  };

  useEffect(() => {
    setContentVisible(false);

    // get the thumbnail image from the gallery
    let thumbnailImage = null;
    data.gallery.forEach(item => {
      if ((item.type === "video" || item.type === "image") && !thumbnailImage) {
        thumbnailImage = item.thumbnail_url;
      }
    });

    setThumbnail(thumbnailImage);
  }, [data]);

  return (
    <div className={`__2 `}>
      <div className={`${contentVisible ? "__2o" : ""}`}>
        <Layout flex addClass="bc12">
          <div
            className="__2b"
            style={{
              backgroundImage: `url(${thumbnail || OverviewThumbnailPlaceholderImg})`,
              backgroundPosition: "center",
              backgroundSize: "cover",
            }}
          ></div>
          <div className="__2a">
            <Title addClass="">
              {data.code ? `${data.code} - ` : ""} {data.title}
            </Title>
            <p>{data.categories[0]}</p>
          </div>
        </Layout>
        <Layout flex justifyContentCenter alignItemsCenter addClass="__2c" clicked={showContent}>
          <Icon iconId="arrowDown" />
        </Layout>
      </div>
      <ToggleOpacity toggle={contentVisible} animationTime={1000} slide>
        <div>{children}</div>
      </ToggleOpacity>
    </div>
  );
};

export default PriviewOverview;
